import { Api } from '../../Api';
import { ISettingsManualApproveGetParams } from './';

export class ManualApprove {
    private static _basePath = '/ManualApprove';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${ManualApprove._basePath}`;
        return {
            async isWaiting({ name }: ISettingsManualApproveGetParams) {
                const path = `/manual/iswaiting/?name=${name}`;
                return await Api.get<boolean>({
                    path: `${basePath}${path}`,
                });
            },
            async approve({ name }: ISettingsManualApproveGetParams) {
                const path = `/manual/approve/?name=${name}`;
                return await Api.post<boolean>({
                    path: `${basePath}${path}`,
                });
            },
        };
    }
}
